import React from 'react';
import styles from './ConclusionCard.module.scss';
import {Grid} from '@material-ui/core';
import {MDBCard, MDBCardBody, MDBCardFooter, MDBCol, MDBRow} from 'mdbreact';
import {Else, If, Then, When} from 'react-if';
import Conclusion from './components/conclusion';
import PurchaseButton
  from 'gui/pages/mainRouter/pages/ad/components/commons/conclusionCard/components/purchaseButton/PurchaseButton';
import SkeletonPlaceHolder, {eSkeletonVariant} from 'gui/components/skeletonPlaceHolder';
import GuaranteesForBuyer
  from 'gui/pages/mainRouter/pages/ad/components/commons/preparedAdStructure/components/purchaseForm/components/guaranteesForBuyer';
import BuyerPoints
  from 'gui/pages/mainRouter/pages/ad/components/commons/preparedAdStructure/components/purchaseForm/components/guaranteesForBuyer/components/buyerPoints';

interface IConclusionCardProps {
  className?: string;
  topTitle?: any;
  bottomTitle?: any;
  top?: any;
  bottom?: any;


  currency?: number;
  originalPrice?: number;
  salePrice?: number;

  showTopPriceConclusion?: boolean;
  showBottomPriceConclusion?: boolean;

  hideDiscount?: boolean;
  hideTop?: boolean;
  hideBottom?: boolean;

  submitForm?: any;
  isSubmitting?: boolean;

  loading?: boolean;

  aboveComponent?: any;

}

const ConclusionCard = ({loading, ...props}: IConclusionCardProps) =>
  <Grid container spacing={2} className={`conclusionCard ${props.className}`.trim()}>
    <Grid item xs={12}>
      <BuyerPoints className={styles.topPoints}/>
      {props.aboveComponent}
      <MDBCard className={styles.conclusionCardContainer}>
        <When condition={!props.hideTop}>
          {() => loading ? <SkeletonPlaceHolder
              variant={eSkeletonVariant.rect}
              className={styles.conclusionCardFormTop}
              height={200}
            /> :
            <MDBCardBody className={styles.conclusionCardFormTop}>
              <When condition={!!props.topTitle}>
                <MDBRow>
                  <MDBCol className={styles.conclusion}>
                    {props.topTitle}
                  </MDBCol>
                </MDBRow>
              </When>
              {props.top}
              <When condition={!!props.showTopPriceConclusion}>
                {() => <Conclusion
                  currency={props.currency}
                  originalPrice={props.originalPrice}
                  salePrice={props.salePrice}
                  hideDiscount={props.hideDiscount}
                />}
              </When>
            </MDBCardBody>
          }
        </When>
        <If condition={!props.hideBottom}>
          <Then>
            {() => loading ? <SkeletonPlaceHolder
                variant={eSkeletonVariant.rect}
                className={styles.conclusionCardFormBottom}
                height={100}
              /> :
              <MDBCardFooter className={styles.conclusionCardFormBottom}>
                <When condition={!!props.bottomTitle}>
                  <MDBRow>
                    <MDBCol className={styles.conclusion}>
                      {props.bottomTitle}
                    </MDBCol>
                  </MDBRow>
                </When>
                <When condition={!!props.showBottomPriceConclusion}>
                  {() => <Conclusion
                    currency={props.currency}
                    originalPrice={props.originalPrice}
                    salePrice={props.salePrice}
                    hideDiscount={props.hideDiscount}
                  />}
                </When>
                <When condition={!!props.submitForm}>
                  {() => <PurchaseButton
                    submitForm={props.submitForm}
                    isSubmitting={props.isSubmitting}
                  />}
                </When>
                {props.bottom}
                <GuaranteesForBuyer/>
              </MDBCardFooter>
            }
          </Then>
          <Else>
            {() => loading ? <SkeletonPlaceHolder
                variant={eSkeletonVariant.rect}
                className={styles.conclusionCardFormBottom}
                height={100}
              /> :
              <MDBCardFooter className={`hideWhen767 ${styles.conclusionCardFormBottom}`}>
                <GuaranteesForBuyer/>
              </MDBCardFooter>
            }
          </Else>
        </If>
      </MDBCard>
    </Grid>
  </Grid>;

ConclusionCard.defaultProps = {
  className: '',
  currency: 0,
  originalPrice: 0,
  salePrice: 0,
  showTopPriceConclusion: false,
  showBottomPriceConclusion: false,

  topTitle: '',
  bottomTitle: '',

  hideTop: false,
  hideBottom: false,
};

export default React.memo(ConclusionCard);
